import React from 'react';
import { Radio, Checkbox } from 'components';
import { IBaseMapSwitcher } from './index';
import './style.scss';

export const BaseLayersListUL = ({
    className = '',
    layersList,
    lng = 'ru',
    currentBaseMapId,
    cadastreIsVisible,
    switchBaseMap,
    showCadastreLayer
}: IBaseMapSwitcher) => (
    <>
        <ul className="oms-base-map-control">
            {layersList.map((item) => {
                let layerName: string = item.name;

                if (item.localized_name) {
                    const nameObj = item.names.find(nameItem => lng in nameItem);
                    if (nameObj) {
                        layerName = nameObj[lng];
                    }
                }

                return (
                    <li key={item.id} className="oms-base-map-control__wrapper">
                        <label className="oms-base-map-control__item">
                            {item.value !== 'cadastre' && (
                                <>
                                    <Radio
                                        checked={currentBaseMapId === item.id}
                                        onChange={() => switchBaseMap(item.id)}
                                    />
                                    <span className="oms-base-map-control__item-name">{layerName}</span>
                                </>
                            )}
                            {item.value === 'cadastre' && (
                                <>
                                    <Checkbox
                                        checked={cadastreIsVisible}
                                        onChange={() => showCadastreLayer(!cadastreIsVisible)}
                                    />
                                    <span className="oms-base-map-control__item-name">{layerName}</span>
                                </>
                            )}
                        </label>
                    </li>
                );
            })}
        </ul>
    </>
);
